import type { TableProps } from 'antd';

import React from 'react';
import { ConfigProvider, Table } from 'antd';
import clsx from 'clsx';

import classes from './estTable.module.scss';

const EST_TABLE_THEME = {
  components: {
    Table: {
      headerBg: '#e7e7e8',
      headerColor: '#272747',
      borderColor: '#e1e1e1',
      fontWeightStrong: 400,
    },
  },
} as const;

export function EstTable<T extends object>({
  className,
  ...props
}: TableProps<T>) {
  return (
    <ConfigProvider theme={EST_TABLE_THEME}>
      <Table<T> {...props} className={clsx(classes.estTable, className)} />
    </ConfigProvider>
  );
}
